import { Button, Row, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../api/axiosClient";
import { useEffect } from "react";

export default function NotVerified() {
  const navigate = useNavigate();
  const location = useLocation();

  // Reachable both from in-app navigation and from a cold SSO deep-link, where the
  // router state may only carry the instance id.
  const instanceId = location.state?.exam_instance?.id;
  const connectUrl = location.state?.saveInstance?.student_connect_url;

  useEffect(() => {
    if (!instanceId) return undefined;
    async function getQuestions() {
      try {
        await axiosClient.get(`examinstances/${instanceId}/questions`);
        navigate("/my-session/exam-instructions", {
          state: location.state,
        });
      } catch (error) {}
    }

    let interval = setInterval(() => {
      getQuestions();
    }, 3000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [location, instanceId]);

  return (
    <div className="my-session-instructions-container">
      <div className="my-session-instructions">
        <h4 style={{ marginBottom: 20 }}>Not Verified</h4>
        <ol>
          <li>
            You have not been verified yet. Please join the meeting and get
            verified first.
          </li>
          <li>
            Once you are verified by the examiner, click the "Start Test" button
            to join the exam.
          </li>
        </ol>
      </div>
      <Row justify={"center"} style={{ marginTop: 30 }}>
        <Space size={"large"}>
          <Button
            type="primary"
            onClick={() =>
              connectUrl
                ? window.open(connectUrl, "_blank")
                : navigate("/my-session")
            }
          >
            {connectUrl ? "Join Meeting" : "Back to My Session"}
          </Button>
        </Space>
      </Row>
    </div>
  );
}
